document.addEventListener('DOMContentLoaded', function () {
    var details = document.querySelector('.header__icon--account details');
    var summary = details?.querySelector('.header__icon--account summary');
    var accountNameLink = document.getElementById('account__name');
    var firstMenuItem = document.querySelector('#account-dropdown .subnav__item:first-child .subnav__link');
  
    // Check if details and summary exist before adding event listeners
    if (details && summary) {
      // Open/close menu on mouse hover
      details.addEventListener('mouseenter', function () {
        details.open = true;
      });
  
      details.addEventListener('mouseleave', function () {
        details.open = false;
      });
  
      // Open menu with Enter key, close with Escape key
      summary.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          details.open = true;
  
          // Move focus to the first submenu item when using keyboard
          if (firstMenuItem) {
            firstMenuItem.focus();
          }
        } else if (e.key === 'Escape') {
          e.preventDefault();
          details.open = false;
          summary.focus(); // Return focus to summary
        }
      });
    }
  
    // Prevent navigation on Enter key when using keyboard
    if (accountNameLink) {
      accountNameLink.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
        }
      });
  
      // Allow navigation when clicking with mouse
      accountNameLink.addEventListener('click', function (e) {
        // Default action allowed
      });
    }
  });